import { RestrictionCourseOrBucket, BucketCourseMap } from "../types";

export const getCourseMessage = (
  blockCourses: RestrictionCourseOrBucket[],
  bucketCourseMap: BucketCourseMap,
  allCourseIds: string[],
  copyOverridePlural: string
): string => {
  if (!blockCourses.length) {
    return `All ${copyOverridePlural}`;
  }

  const blockCourseIds = blockCourses.map((course) => course.id);

  // Find matching buckets
  const restrictionBuckets: RestrictionCourseOrBucket[] = Object.entries(
    bucketCourseMap ?? {}
  )
    .filter(([, { courseIds }]) =>
      courseIds.every((courseId) => blockCourseIds.includes(courseId))
    )
    .map(([bucketId, { name }]) => ({ id: bucketId, name }));

  const matchedCourseIds = new Set(
    restrictionBuckets.flatMap(
      ({ id }) => bucketCourseMap?.[id]?.courseIds ?? []
    )
  );

  const restrictionCourses: RestrictionCourseOrBucket[] = blockCourses.filter(
    (course) => !matchedCourseIds.has(course.id) && course.name !== undefined
  );

  const isAll =
    (restrictionCourses.length === 0 && restrictionBuckets.length === 0) ||
    (allCourseIds.length > 1 &&
      restrictionCourses.length === allCourseIds.length) ||
    (Object.keys(bucketCourseMap).length > 0 &&
      restrictionBuckets.length === Object.keys(bucketCourseMap).length);

  if (isAll) {
    return `All ${copyOverridePlural}`;
  }

  const bucketText = restrictionBuckets?.length
    ? restrictionBuckets.length > 1
      ? `${restrictionBuckets.length} ${copyOverridePlural}`
      : restrictionBuckets[0].name
    : null;

  const courseText = restrictionCourses?.length
    ? restrictionCourses.length > 1
      ? `${restrictionCourses.length} ${copyOverridePlural}`
      : restrictionCourses[0].name
    : null;

  return (
    [bucketText, courseText].filter(Boolean).join(" & ") ||
    `All ${copyOverridePlural}`
  );
};
